import { FunctionComponent } from "react";
import { MondialRelayLocation } from "@Types/addresses";
import CheckoutPickupLocationItem from "./CheckoutPickupLocationItem";
import "./style.scss";

interface Props {
  locations: MondialRelayLocation[];
  onSelectLocation: (location: MondialRelayLocation) => void;
}

const CheckoutPickupLocations: FunctionComponent<Props> = ({ locations, onSelectLocation }) => {
  return (
    <div className="CheckoutPickupLocations">
      {locations.map((location) => {
        return (
          <CheckoutPickupLocationItem
            key={location.mondialRelayNumber}
            location={location}
            onSelectLocation={onSelectLocation}
          />
        );
      })}
    </div>
  );
};

export default CheckoutPickupLocations;
